import { Outlet } from "react-router-dom"
import {Datapad} from "./DataPad/Datapad";

export const Layout = () => {
	return <>
		<Datapad >
			<Outlet />
		</Datapad>
	</>
}